/** Portal Manta · DocsPage · v29.2 modular */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { KB_REPO } from '../../data/kb-repo.js';
import { LOCAL_FILES } from '../../data/local-files.js';
import { THl, TH, TDl, TD } from '../../app-globals.js';

const DocsPage = memo(function DocsPage_Inner({lote}){
  const [filtro,setFiltro]=useState('Todos');
  // Filtra KB_REPO pelos docs que têm tag Lx correspondente + docs genéricos (normas, referências)
  const lxTag='L'+(lote.sig||'').replace(/\D/g,'');
  const docsDoLote=KB_REPO.filter(d=>d.tags.includes(lxTag)||['Norma','Referência'].includes(d.tipo));
  const tipos=['Todos',...new Set(docsDoLote.map(d=>d.tipo))];
  const rows=docsDoLote.filter(d=>filtro==='Todos'||d.tipo===filtro);
  const statCor={indexado:{bg:V.gnb,c:V.gn},curado:{bg:V.orp,c:V.or},processando:{bg:V.blb,c:V.bl},erro:{bg:'#FEF2F2',c:'#B91C1C'}};
  return(<div style={{padding:'14px 17px',overflowY:'auto',flex:1}}>
    <div style={{marginBottom:12}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3}}>
        <div style={{fontSize:14,fontWeight:700,color:V.br}}>Documentos do Lote</div>
        <span style={{padding:'2px 8px',background:V.blb,color:V.bl,fontSize:9,fontWeight:700,borderRadius:12}}>ANTT</span>
        <span style={{padding:'2px 8px',background:V.orp,color:V.or,fontSize:9,fontWeight:700,borderRadius:12}}>{lote.sig}</span>
      </div>
      <div style={{fontSize:10.5,color:V.g5}}>{docsDoLote.length} documentos associados a este lote · editais, MEF, projetos, normas aplicáveis</div>
    </div>
    {/* Arquivos locais do computador */}
    <div style={{background:'linear-gradient(135deg,#fff7ed,#ffedd5)',border:`1px solid ${V.orm}`,borderRadius:10,padding:'12px 14px',marginBottom:14}}>
      <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:8}}>⊟ Arquivos Locais — Links Diretos</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:6}}>
        {LOCAL_FILES.map(f=>{
          const lkTag='L'+(lote.sig||'').replace(/\D/g,'');
          const isRel=f.desc.toLowerCase().includes('lote '+(lote.sig||'').replace(/\D/g,'').toLowerCase())||f.desc.toLowerCase().includes('portal')||f.desc.toLowerCase().includes('cobertura');
          return(<a key={f.id} href={`file:///${f.path.replace(/\\/g,'/')}`} target="_blank" rel="noopener noreferrer"
            style={{display:'flex',alignItems:'center',gap:8,padding:'7px 10px',background:isRel?'#fff':'rgba(255,255,255,0.6)',border:`1px solid ${isRel?V.orm:V.g2}`,borderRadius:7,textDecoration:'none',transition:'all .1s'}}
            onMouseEnter={e=>{e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)';}}
            onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';}}>
            <span style={{fontSize:16,flexShrink:0}}>{f.tipo==='JSON'?'{}':f.tipo==='XLSX'?'📊':f.tipo==='MD'?'📄':'📁'}</span>
            <div style={{minWidth:0}}>
              <div style={{fontSize:10.5,fontWeight:600,color:V.br,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{f.desc}</div>
              <div style={{fontSize:8.5,color:V.g4,fontFamily:'monospace',marginTop:1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{f.path.split('\\').pop()}</div>
            </div>
            <span style={{fontSize:9,color:V.g4,flexShrink:0,marginLeft:'auto'}}>↗</span>
          </a>);
        })}
      </div>
      <div style={{fontSize:9,color:V.g5,marginTop:8}}>Clique para abrir no aplicativo padrão · links file:// · funciona em ambiente local</div>
    </div>
    <div style={{display:'flex',gap:5,marginBottom:10,flexWrap:'wrap'}}>
      {tipos.map(t=>{
        const on=filtro===t;
        const ct=docsDoLote.filter(d=>t==='Todos'||d.tipo===t).length;
        return(<button key={t} onClick={()=>setFiltro(t)} style={{padding:'4px 10px',borderRadius:16,fontSize:10,fontWeight:on?700:500,border:`1px solid ${on?V.or:V.g2}`,background:on?V.or:'#fff',color:on?'#fff':V.g5,cursor:'pointer',fontFamily:'inherit'}}>{t} · {ct}</button>);
      })}
    </div>
    <div style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:10,overflow:'hidden'}}>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead><tr style={{background:V.g1}}>
          <th style={{...THl,width:90}}>Tipo</th>
          <th style={THl}>Referência</th>
          <th style={{...THl,width:90}}>Data</th>
          <th style={{...TH,width:70}}>Pag.</th>
          <th style={{...THl,width:180}}>Tags</th>
          <th style={{...THl,width:110}}>Status</th>
        </tr></thead>
        <tbody>{rows.length===0?(<tr><td colSpan={6} style={{padding:20,textAlign:'center',color:V.g4,fontSize:11}}>Sem documentos neste filtro.</td></tr>):rows.map((d,i)=>{
          const st=statCor[d.status]||{bg:V.g1,c:V.g5};
          return(<tr key={d.id} style={{borderBottom:`1px solid ${V.g1}`,background:i%2===0?'#fff':V.g0}}>
            <td style={{...TDl,padding:'6px 10px'}}><span style={{fontSize:9.5,fontWeight:700,color:V.br2,background:V.orp,padding:'2px 6px',borderRadius:4}}>{d.tipo}</span></td>
            <td style={{...TDl,padding:'6px 10px',fontSize:10.5,color:V.br}}>
              <div style={{fontWeight:600}}>{d.ref}</div>
              <div style={{fontSize:9,color:V.g4,fontFamily:'monospace',marginTop:2}}>{d.id} · {d.src}</div>
            </td>
            <td style={{...TDl,padding:'6px 10px',fontSize:10,color:V.g5,fontFamily:'monospace'}}>{d.data}</td>
            <td style={{...TD,padding:'6px 10px',fontSize:10,color:V.g5}}>{d.paginas??'—'}</td>
            <td style={{...TDl,padding:'6px 10px'}}>
              <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
                {d.tags.map(t=>(<span key={t} style={{fontSize:8.5,color:V.g5,background:V.g1,padding:'1px 5px',borderRadius:3}}>{t}</span>))}
              </div>
            </td>
            <td style={{...TDl,padding:'6px 10px'}}><span style={{fontSize:9.5,fontWeight:600,color:st.c,background:st.bg,padding:'2px 7px',borderRadius:10}}>● {d.status}</span></td>
          </tr>);
        })}</tbody>
      </table>
    </div>
  </div>);
});

export { DocsPage };
export default DocsPage;
